import React, { useState } from "react";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { servicesData } from "./servicesData";
import "./Services.css";

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  const cardVariants = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", bounce: 0.4, duration: 0.8 },
    },
  };

  const heroImage = "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80";

  return (
    <div className="vero-services">
    
      <section 
        className="vero-services__hero"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="vero-services__hero-overlay"></div>
        <div className="vero-services__hero-content">
          <h1 className="vero-services__hero-title">Driving Digital Transformation.</h1>
          <p className="vero-services__hero-subtitle">Empowering businesses with cutting-edge technology solutions that redefine possibilities.</p>
        </div>
      </section>

      {/* Services Grid */}
      <h1 className="vero-services__title">Our Services</h1>
      <p className="vero-services__intro">
        At Vero Disruptors, we offer a range of services designed to help your
        business thrive in the digital age. Here's what we provide:
      </p>

      <div className="vero-services__grid">
        {servicesData.map((service) => (
          <motion.div
            key={service.id}
            className="vero-services__card"
            style={{ backgroundImage: `url(${service.image})` }}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.5 }}
            variants={cardVariants}
            whileHover={{ scale: 1.05 }}
            onClick={() => setSelectedService(service)}
          >
            <div className="vero-services__card-overlay">
              <h2 className="vero-services__card-title">{service.title}</h2>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Pop-up Modal */}
      {selectedService && (
        <div className="vero-services__modal-overlay">
          <motion.div
            className="vero-services__modal"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
          >
            <button
              className="vero-services__modal-close"
              onClick={() => setSelectedService(null)}
            >
              &times;
            </button>
            <h2 className="vero-services__modal-title">{selectedService.title}</h2>
            <p className="vero-services__modal-content">{selectedService.popupContent}</p>
            <Link
              to={`/services/${selectedService.id}`}
              className="vero-services__modal-link"
            >
              Read More
            </Link>
          </motion.div>
        </div>
      )}

      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Vero Disruptors is a leading innovator in data-driven solutions, providing cutting-edge services to help businesses grow and succeed.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1AF81Af26p/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              
              <a href="https://www.linkedin.com/company/vero-disruptors-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              
            </div>
            
          </div>
          
        </div>
        <div className="footer-legal-links">
        
        <a href="/contactus">Contact Us</a>
        <a href="/terms">Term Of Use</a>
        <a href="/privacy">Privacy Statement</a>
        <a href="/refund">            Refund Policy
      </a>
        <a href="/about">About Us</a>
      
      </div>
      
        <div className="contactus-footer">
          <p>Copyright © Vero Disruptors {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </footer>
      
    </div>
  );
};

export default Services;